module.exports = __webpack_public_path__ + "img/petralogo.5c8557fb.png";